var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "el-card",
        { staticClass: "card-container", attrs: { shadow: "hover" } },
        [
          _c("filtro", {
            attrs: {
              listaProcessosSelecionados: _vm.processosSelecionados.map(
                function(processo) {
                  return processo.id
                }
              ),
              configuracaoFiltro: _vm.configuracaoFiltro
            },
            on: { pesquisar: _vm.pesquisar, limpar: _vm.clear }
          })
        ],
        1
      ),
      !_vm.loading
        ? _c("app-listagem", {
            attrs: {
              headerLabel: "Adicionar/Remover Processos",
              showButtonOrdemServico: false,
              "has-refresh-button": true,
              "json-headers": _vm.colunas,
              "json-data": _vm.items,
              totalElements: _vm.totalElements,
              pagina: _vm.filtro.pagina,
              isVincularEquipe: true
            },
            on: {
              updateListagem: _vm.carregarLista,
              changePage: _vm.changePage,
              sort: _vm.sortEdicao,
              executar: _vm.executar,
              selectItem: _vm.selecionaProcesso
            }
          })
        : _vm._e(),
      _c("span", { staticClass: "padding-left" }, [
        _vm._v(_vm._s("Processos Selecionados: " + this.processos.length))
      ])
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-09599230", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-09599230","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/screens/analise/listagem/ListagemProcessoOrdemServico.vue
// module id = null
// module chunks = 